<template>
    <b-container>
        <b-row>
            <b-col>
                <h3>User Dashboard</h3>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    export default {
        name: "user-dashboard"
    }
</script>

<style lang="scss">

</style>